import React from "react";
import { cx } from "components/crm/ui/uiUtils";

const Switch = ({ checked, onChange, label }) => (
  <label className="flex cursor-pointer items-center justify-between gap-4 text-sm font-medium leading-5 text-ink">
    {label}
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      onClick={() => onChange(!checked)}
      className={cx(
        "relative h-6 w-11 shrink-0 rounded-full transition-colors",
        checked ? "bg-primary" : "bg-lineStrong"
      )}
    >
      <span
        className={cx(
          "absolute top-0.5 size-5 rounded-full bg-white shadow transition-all",
          checked ? "left-[22px]" : "left-0.5"
        )}
      />
    </button>
  </label>
);

export default Switch;
